import { CoinVertical } from "@phosphor-icons/react";
import clsx from "clsx";

export const LineItem: React.FC<{ label: string; value: number }> = ({
  label,
  value,
}) => {
  return (
    <div className="flex items-baseline justify-between text-sm">
      {label}
      <div
        className={clsx(
          "flex items-center gap-2 text-2xl",
          value < 0 && "text-error",
        )}
      >
        {value.toLocaleString()}
        <CoinVertical className="size-6" />
      </div>
    </div>
  );
};
